import React from "react";

const Player = ({ name, captain, teamRole, leagueType }) => {
  let classes = ["player"];
  let leagueTypes = [];
  let typeText;
  let playerType;

  const assistant = teamRole === "Assistant";

  if (captain) {
    classes.push("captain");
    typeText = "(C)";
  }

  if (assistant) {
    classes.push("assistant");
    typeText = "(A)";
  }

  if (captain || assistant) {
    playerType = <div className="player--details--type">{typeText}</div>;
  }

  if (leagueType === 1 || leagueType === 3 || leagueType === 5 || leagueType === 7) {
    leagueTypes.push(<div className="type--d"></div>);
    
  }

  if (leagueType === 2 || leagueType === 3 || leagueType === 6 || leagueType === 7) {
    leagueTypes.push(<div className="type--j"></div>);
  }

  if (leagueType === 4 || leagueType === 5 || leagueType === 6 || leagueType === 7) {
    leagueTypes.push(<div className="type--b"></div>);
  }

  return (
    <div className={classes.join(" ")}>
      <div className="player--details">
        <div className="player--details--name">{name}</div>
        {playerType}
      </div>
      <div className="player--league--types">{leagueTypes}</div>
    </div>
  );
};

export default Player;



// WEBPACK FOOTER //
// ./src/components/player/player.js